import React, { useState } from "react";
import { useSelector } from "react-redux";
import Widget from "../../../features/widget/Widget";
import iconsList from "../../../ui/icons/iconsList";
import pathRouts from "../../../../enums/pathRoute";
import { monthsAllLang } from "../../../../utils/utils";
import CalendarWeekEvents, { eventsDisplayPolicyTypes } from "../calendarWidget/calendarWeekEvents/CalendarWeekEvents";
import classes from "./CalendarMobileWidget.module.css";

const CalendarMobileWidget = () => {

    const { lang } = useSelector(state => state.translate);
    const [selectedDate] = useState(new Date());

    return (
        <Widget
            color="#C5D7E4"
            width={245}
            height={100}
            title={`${selectedDate.getDate()} ${monthsAllLang[selectedDate.getMonth()]?.[lang]} ${selectedDate.getFullYear()}`}
            icon={iconsList.calendar}
            className={classes.CalendarMobileWidget}
            mainLink={`/${pathRouts.CALENDAR}`}
        >
            <div className={classes.EventsList}>
                <CalendarWeekEvents selectedDate={selectedDate} eventsDisplayPolicy={{ strategy: eventsDisplayPolicyTypes.todayOrNextEvents, nextEventsCount: 3 }} newStyle />
            </div>
        </Widget>
    );
};

export default CalendarMobileWidget;
